<template>
  <div>
    <h4>Maladies</h4>
    
    <data-table
      :data-source="maladies"
      :headers="headers"
      table-class="table-striped table-hover"
    >
      <template slot="actions">
        <a
          href="javascript:void(0)"
          class="btn btn-outline-primary btn-icon"
          data-toggle="modal"
          data-target="#add-maladie"
        >
          <i class="icofont icofont-plus" />
        </a>
      </template>
    </data-table>
        
        
        
    <modal
      title="Ajout d'une maladie"
      id="add-maladie"
      :footer="false"
    >
      <form
        class="form-horizontal"
        @submit.prevent="adding"
      >
        <div
          class="alert alert-danger"
          v-if="has_error"
        >
          {{ error_msg }}
        </div>
        <div class="form-group">
          <label for="add-libelle">Libelle</label>
          <input
            id="add-libelle"
            name="add-libelle"
            type="text"
            class="form-control"
            v-model="libelle"
          >
        </div>
        <div class="form-group">
          <label for="add-type">Type</label>
          <select
            name="add-type"
            id="add-type"
            class="form-control"
            v-model="type"
            v-select="{placeholder:'Selectoinnez le type de maladie'}"
          >
            <option value="" />
            <option
              v-for="(t,i) in types"
              :key="i"
              :value="t.uid"
            >
              {{ t.libelle }}
            </option>
          </select>
        </div>
        <div class="form-group text-right">
          <button
            type="submit"
            class="btn btn-primary"
          >
            Ajouter
          </button>
        </div>
      </form>
    </modal>

    <modal
      title="Modification du type d'maladie"
      id="update-maladie"
      :footer="false"
    >
      <form
        class="form-horizontal"
        @submit.prevent="editing"
      >
        <div
          class="alert alert-danger"
          v-if="has_error"
        >
          {{ error_msg }}
        </div>
        <div class="form-group">
          <label for="add-libelle">Libelle</label>
          <input
            id="add-libelle"
            name="add-libelle"
            type="text"
            class="form-control"
            v-model="libelle"
          >
        </div>
        <div class="form-group">
          <label for="update-type">Type</label>
          <select
            name="update-type"
            id="update-type"
            class="form-control"
            v-model="type"
            v-select="{placeholder:'Selectoinnez le type de maladie'}"
          >
            <option value="" />
            <option
              v-for="(t,i) in types"
              :key="i"
              :value="t.uid"
            >
              {{ t.libelle }}
            </option>
          </select>
        </div>
        <div class="form-group text-right">
          <button
            type="submit"
            class="btn btn-primary"
          >
            Enregistrer
          </button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import DataTable from '../../../../components/dataTable/local.vue'
import { COMPONENT_TYPE, TEXT_TYPE } from '../../../../components/dataTable/dataType'
import Modal from '../../../../components/modal.vue'
import { ADD_MALADIE, UPDATE_MALADIE } from '../../../../graphql/sanitaire'
const Type = () => import('../../../../components/admin/sanitaire/maladie/type.vue')
const Actions = () => import('../../../../components/admin/sanitaire/maladie/actions.vue')
export default {
    components: { DataTable, Modal},
    data(){
        return {
            type: null,
            libelle: null,
            has_error: false,
            error_msg: null
        }
    },
    watch: {
        selectedType: {
            handler(){
                if(this.selectedType !== null) {
                    this.libelle = this.selectedType.libelle
                    this.type = this.selectedType.type
                }
            },
            deep: true
        }
    },
    methods: {
        ...mapMutations({
            done: 'DONE',
            setSelectedObject: 'SET_SELECTED_OBJECT'
        }),
        initForm(){
            this.setSelectedObject(null)
            this.libelle = null
            this.type = null
            this.has_error = false
            this.error_msg = null
        },
        adding(){
            let data = {
                libelle: this.libelle,
                type: this.type
            }
            this.$apollo.mutate({
                mutation: ADD_MALADIE,
                variables: {
                    "maladie": {
                        ...data
                    }
                },
                update: (d) => {
                    console.log(d)
                    console.log(`Maladie ${this.libelle} add successfully`)
                }
              }).then(() => {
                this.initForm()
                this.done()
            }).catch((error) => {
                console.error(error)
                this.has_error = true
                this.error_msg = error
            })
        },
        editing(){
            let data = {
                libelle: this.libelle,
                type: this.type
            }
            this.$apollo.mutate({
                mutation: UPDATE_MALADIE,
                variables: {
                    "maladie": {
                        ...data
                    },
                    "uid": this.selectedType.uid
                },
                update: (d) => {
                    console.log(d)
                    console.log(`Maladie ${this.libelle} on ${this.selectedType.uid} updated successfully`)
                }
              }).then(() => {
                this.initForm()
                this.done()
            }).catch((error) => {
                console.error(error)
                this.has_error = true
                this.error_msg = error
            })
        }
    },
    computed: {
        ...mapGetters({
            types: 'sanitaire/typeMaladies',
            maladies: 'sanitaire/maladies',
            selectedType: 'selectedObject'
        }),
        headers(){
            return [
                {label: 'ID', name: 'uid', type: TEXT_TYPE},
                {label: 'Libelle', name: 'libelle', type: TEXT_TYPE, sortable: true},
                {label: 'Type de maladie', name: 'type', type: COMPONENT_TYPE, component: Type},
                {label: 'Actions', name: 'action', type: COMPONENT_TYPE, component: Actions}
            ]
        }
    }
}
</script>

<style>

</style>